import { FacetModel } from "./../models/facet";
import Marionette from "../../shared/marionette-mustache";
import { SearchModel } from "../../search/models/search";
import { CategoryFilterView } from "../../search/views/category-filter";
import { backboneViewProperties } from "../../decorators/backbone-properties";

import { autoinject } from "aurelia-dependency-injection";

const dom = {
    CHECK_ALL_BUTTON: ".js-category-filters-all",
    CHECK_NONE_BUTTON: ".js-category-filters-none",
    CATEGORY_FILTER_NO_MATCHES: "#no-categories-message"
};

@backboneViewProperties({
    tagName: "ul",
    childView: CategoryFilterView,
})
export class CategoryFiltersView extends Marionette.CollectionView<FacetModel, CategoryFilterView> {

    constructor(options?) {
        super(options);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/category-filters.ts